import React, { useState, useEffect } from "react";
import "./OurClients.css";
import client1 from "../assests/images/our-clients/1.jpeg";
import client2 from "../assests/images/our-clients/2.jpeg";
import client3 from "../assests/images/our-clients/3.jpeg";
import client4 from "../assests/images/our-clients/4.jpeg";
import client5 from "../assests/images/our-clients/5.jpeg";
import client6 from "../assests/images/our-clients/6.jpeg";
import client7 from "../assests/images/our-clients/7.jpeg";
import client8 from "../assests/images/our-clients/8.jpeg";
import client9 from "../assests/images/our-clients/9.jpeg";
import client10 from "../assests/images/our-clients/10.jpeg";

const OurClients = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  // Client logos data - using placeholder logos for demonstration
  const clientLogos = [
    {
      name: "Lilac Vanity",
      logo: client1,
      bgColor: "#ffffff",
    },
    {
      name: "Pikaball",
      logo: client2,
      bgColor: "#ffffff",
    },
    {
      name: "Anushthan",
      logo: client3,
      bgColor: "#ffffff",
    },
    {
      name: "Pup n Treats",
      logo: client4,
      bgColor: "#ffffff",
    },
    {
      name: "ETI Never Ending",
      logo: client5,
      bgColor: "#ffffff",
    },
    {
      name: "Broadway Building Solutions Inc.",
      logo: client6,
      bgColor: "#ffffff",
    },
    {
      name: "Ramesth",
      logo: client7,
      bgColor: "#ffffff",
    },
    {
      name: "Nachiketa Schools",
      logo: client8,
      bgColor: "#ffffff",
    },
    {
      name: "IMPC",
      logo: client9,
      bgColor: "#ffffff",
    },
    {
      name: "Doon Valley Public School",
      logo: client10,
      bgColor: "#ffffff",
    },
  ];

  // Calculate slides (5 logos per slide on desktop, 2 on tablet, 1 on mobile)
  const getLogosPerSlide = () => {
    if (window.innerWidth >= 1200) return 5;
    if (window.innerWidth >= 768) return 3;
    if (window.innerWidth >= 576) return 2;
    return 1;
  };

  const [logosPerSlide, setLogosPerSlide] = useState(getLogosPerSlide());
  const totalSlides = Math.ceil(clientLogos.length / logosPerSlide);

  // Handle window resize
  useEffect(() => {
    const handleResize = () => {
      setLogosPerSlide(getLogosPerSlide());
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Auto-advance carousel
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % totalSlides);
    }, 3000); // Change slide every 3 seconds

    return () => clearInterval(interval);
  }, [totalSlides]);

  // Get current slide logos
  const getCurrentSlideLogos = () => {
    const startIndex = currentSlide * logosPerSlide;
    return clientLogos.slice(startIndex, startIndex + logosPerSlide);
  };

  return (
    <div
      className="container-fluid py-5"
      style={{ backgroundColor: "#ffffff" }}
    >
      <div className="container">
        {/* Header */}
        <div className="row mb-5">
          <div className="col-12 text-center">
            <h2 className="display-4 fw-bold mb-0">
              Our <span style={{ color: "#ffc107" }}>Clients</span>
            </h2>
          </div>
        </div>

        {/* Carousel Section */}
        <div className="row">
          <div className="col-12">
            <div
              className="py-4 px-3 rounded-3"
              style={{
                backgroundColor: "#e5e5e5",
                minHeight: "150px",
                overflow: "hidden",
              }}
            >
              <div className="row align-items-center justify-content-center h-100">
                {getCurrentSlideLogos().map((client, index) => (
                  <div
                    key={`${currentSlide}-${index}`}
                    className="col text-center"
                    style={{
                      animation: `fadeInScale 0.8s ease-out ${
                        index * 0.1
                      }s both`,
                    }}
                  >
                    <div
                      className="client-logo-container p-3 rounded-3 mx-2 d-flex align-items-center justify-content-center"
                      style={{
                        backgroundColor: client.bgColor,
                        minHeight: "100px",
                        boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
                        transition: "all 0.3s ease",
                      }}
                    >
                      <img
                        src={client.logo}
                        alt={client.name}
                        className="img-fluid"
                        width="100%"
                        height="100%"
                        style={{
                          maxHeight: "100px",
                          maxWidth: "150px",
                          objectFit: "contain",
                          // filter: "grayscale(100%)",
                          transition: "filter 0.3s ease",
                        }}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Progress Indicators */}
        <div className="row mt-4">
          <div className="col-12 text-center">
            {Array.from({ length: totalSlides }, (_, index) => (
              <span
                key={index}
                className={`d-inline-block rounded-circle mx-1 ${
                  index === currentSlide ? "bg-warning" : "bg-secondary"
                }`}
                style={{
                  width: "8px",
                  height: "8px",
                  opacity: index === currentSlide ? 1 : 0.5,
                  transition: "all 0.3s ease",
                }}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurClients;
